import { makeStyles, createStyles, Theme, alpha } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      minHeight: 144,
      display: 'flex',
      flexDirection: 'column',
      userSelect: 'none',
      position: 'relative',
    },
    noData: {
      alignItems: 'center',
      justifyContent: 'center',
      userSelect: 'none',
    },
    title: {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.text.hint,
      marginBottom: theme.spacing(2),
      userSelect: 'none',
    },
    levelsContainer: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      top: 0,
      left: 0,
      height: '100%',
      zIndex: 0,
      userSelect: 'none',
    },
    level: {
      flex: 1,
      width: '100%',
      userSelect: 'none',

      '&.bordered': {
        borderTop: `0.5px dashed ${theme.palette.grey[300]}`,
      },
    },
    chartContainer: {
      display: 'grid',
      gridColumnGap: theme.spacing(0.75),
      position: 'relative',
      height: '100%',
      padding: `0 ${theme.spacing(1)}px`,
      userSelect: 'none',
    },
    barsContainer: {
      display: 'flex',
      cursor: 'zoom-in',
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.standard,
      }),

      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[300], 0.5),
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
      },

      '& > * + *': {
        marginLeft: theme.spacing(0.25),
      },
    },
    barContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      flex: 1,
      alignItems: 'center',
      height: '100%',
      zIndex: 10,
      position: 'relative',
      userSelect: 'none',
    },
    barLabel: {
      fontSize: theme.typography.pxToRem(12),
      marginBottom: theme.spacing(0.5),
      position: 'absolute',
      top: -theme.spacing(2),
      userSelect: 'none',
    },
    bar: {
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      width: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      userSelect: 'none',

      '&.no-radius': {
        borderRadius: 0,
      },
    },
    levelLabelsContainer: {
      display: 'grid',
      gridColumnGap: theme.spacing(0.5),
      position: 'relative',
      width: '100%',
      padding: `0 ${theme.spacing(1)}px`,
      userSelect: 'none',
    },
    levelLabelWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      userSelect: 'none',
    },
    levelLabel: {
      fontSize: theme.typography.pxToRem(10),
      userSelect: 'none',
    },
    noDataIconWrapper: {
      width: 58,
      height: 58,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.grey[200],
      borderRadius: '50%',
      userSelect: 'none',
    },
    noDataIcon: {
      color: '#f7f7f7',
      fontSize: 24,
      transform: 'translate(2px, 2px)',
      userSelect: 'none',
    },
  }),
);
